import React, { ChangeEvent, PropsWithChildren } from 'react';
import { CheckboxCheckedIcon, CheckboxUncheckedIcon } from '../../assets/icons';
import clsx from 'clsx';

export const GrowegyCheckbox = ({
  checked,
  defaultChecked,
  text,
  dataTestPrefix,
  disabled,
  narrow,
  labelClassName,
  checkedClassName,
  onChange,
  children,
}: PropsWithChildren<{
  checked?: boolean;
  defaultChecked?: boolean;
  text?: string;
  dataTestPrefix: string;
  disabled?: boolean;
  narrow?: boolean;
  labelClassName?: string;
  checkedClassName?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}>) => (
  <label
    className={clsx(
      'growegy-checkbox__label',
      labelClassName,
      {
        'growegy-checkbox__label--disabled': disabled,
      },
      { 'growegy-checkbox__label--narrow': narrow }
    )}
    data-test={`${dataTestPrefix}__label`}
  >
    <input
      className="growegy-checkbox"
      type="checkbox"
      defaultChecked={defaultChecked}
      onChange={onChange}
      checked={checked}
      disabled={disabled}
    />
    <div className="growegy-checkbox__icons">
      <CheckboxCheckedIcon
        data-test={`${dataTestPrefix}__icon--checked`}
        className={clsx('growegy-checkbox__icon--checked', checkedClassName)}
      />
      <CheckboxUncheckedIcon
        data-test={`${dataTestPrefix}__icon--unchecked`}
        className="growegy-checkbox__icon--unchecked"
      />
    </div>
    {text && <div>{text}</div>}
    {children}
  </label>
);
